document.addEventListener('DOMContentLoaded', function() {
  const langSwitchButton = document.getElementById('lang-switch');
  const enContent = document.getElementById('en-content');
  const deContent = document.getElementById('de-content');
  const enSpan = document.getElementById('en-span');
  const deSpan = document.getElementById('de-span');

  // Set default language to German
  enContent.style.display = 'none';   // Hide English content
  deContent.style.display = 'block';  // Show German content
  deSpan.classList.add('active-lang');
  enSpan.classList.remove('active-lang');

  langSwitchButton.addEventListener('click', function() {
    if (enContent.style.display === 'none') {
      enContent.style.display = 'block';
      deContent.style.display = 'none';
      enSpan.classList.add('active-lang');
      deSpan.classList.remove('active-lang');
    } else {
      enContent.style.display = 'none';
      deContent.style.display = 'block';
      deSpan.classList.add('active-lang');
      enSpan.classList.remove('active-lang');
    }
  });
});
